import $ from 'jquery';
import Vue from 'vue';
import App from './Template/App.vue';
import store from './Template/Store/store.js';

window.appShindanVue = new Vue({
  store,
  render: h => h(App),// eslint-disable-line
}).$mount('#app-shindan');


$(document).on(
  'closed',
  '.modal__shindan',
  function () {
    window.appShindanVue.$store.commit('reset');
  },
);
